// Warning: This file is deprecated. Please use popularProductsService, kept for old header support
// TODO: When old header is no longer supported, remove remaining usages of this file and delete
import { ConfigService } from "@nuskin/ns-util";
import axios from "axios";

const COUNTRY_CODE_KEY = "{countryCode}";
const POPULAR_PRODUCT_URL = "/popularproducts/v1/" + COUNTRY_CODE_KEY;

export default {
  getPopularProducts
};

/**
 * Returns a promise of the popular product service. This data is populated through Big Query in GTM.
 * @param countryCode
 * @return {Promise.<*>}
 */
async function getPopularProducts(countryCode) {
  let config = ConfigService.getMarketConfig();

  return await axios.request({
    method: "get",
    url:
      config.awsUrl +
      POPULAR_PRODUCT_URL.replace(COUNTRY_CODE_KEY, countryCode),
    headers: _getHeaders(),
    responseType: "json"
  });
}

/**
 * Returns headers needed for vgService VG-Dist-Info service call
 * @returns {{Content-Type: string, client_id: string, client_secret: string}}
 * @private
 */
function _getHeaders() {
  let config = ConfigService.getMarketConfig();

  return {
    "Content-Type": "application/json",
    client_id: config.checkout.clientId,
    client_secret: config.checkout.clientSecret
  };
}
